import { BetBuilderPickResponse } from "@api-types/bet-booster/BetBuilderPickResponse";
import { indicator } from "./indicator";
import { Result } from "@gp/models";
import { observable } from "mobx";
import { MultiOffers } from "./MultiOffers";
import { nullAndLengthCheckArray } from "@gp/utility";

export type TBetBuilderPick = BetBuilderPickResponse & {
	indicator: indicator;
};

export class BetBuilderPick {
	@observable bbMaxCoefficient: number;
	companyId: string;
	eventId: string;
	id: string;
	@observable isLive: boolean;
	@observable multiOffers: MultiOffers[];
	@observable result: Result | null;
	sportAbrv: string;
	sportName: string;
	sportId: string;
	sportSortOrder: number;
	startTime: string | null = null;
	@observable indicator: indicator;
	constructor(bbpick: TBetBuilderPick) {
		this.bbMaxCoefficient = bbpick.bbMaxCoefficient;
		this.companyId = bbpick.companyId;
		this.eventId = bbpick.eventId;
		this.id = bbpick.id;
		this.isLive = bbpick.isLive;
		this.multiOffers = bbpick.multiOffers.map(
			(offer) => new MultiOffers(offer)
		);
		this.result = null;
		this.sportAbrv = bbpick.sportAbrv;
		this.sportName = bbpick.sportName;
		this.sportId = bbpick.sportId;
		this.sportSortOrder = bbpick.sportSortOrder || 9999;
		this.indicator = bbpick.indicator; // Assuming 'indicator' exists in bbpick
		if (nullAndLengthCheckArray(bbpick.multiOffers)) {
			this.startTime = bbpick.multiOffers[0].sportData?.startTime;
		}
	}
}
